// Reel.js
import React from 'react';
import Card from './Card';

function Reel({reelId, symbols, spinning, reelsTextMap}) {
    return (
        <div className={`reel ${spinning ? 'spinning' : ''}`}>
            {symbols.map((symbol, rowIndex) => <Card key={rowIndex} reelId={reelId} symbol={symbol} reelsTextMap={reelsTextMap}/>)}
        </div>
    );
}

export default Reel;
